// import React, { useEffect, useState } from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Typography,
//     IconButton,
//     Stack,
//     Chip,
//     Button,
//     Box,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     Divider
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import QaParameters from "./commonQaparameter";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import apiEndPointsConfig from "../services/apiEndPoints";
// import axios from "axios";


// const QAParametersModal = ({ open, onClose, processName, setOpenQA }) => {
//     const [openAddModal, setOpenAddModal] = useState(false);
//     const [parameter, setParameters] = useState({});
//     const [shortParams, setShortParams] = useState([]);

//     // 1) Convert function
// const convertToShortFormat = (paramObj) => {
//     console.log("Original paramObj:", paramObj);

//     if (!paramObj) return [];

//     // If JSON is a string, parse it
//     if (typeof paramObj === "string") {
//         try {
//             paramObj = JSON.parse(paramObj);
//         } catch (error) {
//             console.log("JSON parse error:", error);
//             return [];
//         }
//     };
//     if (Array.isArray(paramObj)) {
//         console.log("Detected array → extracting index 0");
//         paramObj = paramObj[0];
//     }
//     // If still not an object, return empty
//     if (typeof paramObj !== "object" || paramObj === null) return [];

//     // Now convert to desired format
//     return Object.keys(paramObj).map((key) => {
//         const category = paramObj[key];
//         console.log(category , "category");

//         return {
//             name: key,
//             severity: category.criticality || "",
//             color:
//                 category.criticality === "MostCritical"
//                     ? "error"
//                     : category.criticality === "Critical"
//                     ? "warning"
//                     : "default",
//             subParams: category.subParameters?.length || 0
//         };
//     });
// };
//     // 2) Fetch API only once on mount
//     useEffect(() => {
//         const fetchQAParameters = async () => {
//             try {
//                 const response = await axios.post(
//                     apiEndPointsConfig.defaultListOfQAparameter,
//                     { process: "MASTER-SALES" },
//                     { headers: { "Content-Type": "application/json" } }
//                 );

//                 const apiData = response.data?.data?.prompt?.qaParameterPrompt?.systemPrompts?.m6;
//                 console.log(apiData , "apiData");

//                 setParameters(apiData);
//                 const formatted = convertToShortFormat(apiData);
//                 console.log(formatted , "formatted");

//                 setShortParams(formatted);

//                 console.log("Converted Params:", formatted);

//             } catch (error) {
//                 console.log("Status:", error.response?.status);
//                 console.log("Server response:", error.response?.data);
//             }
//         };

//         fetchQAParameters();
//     }, []);

//     // const parameters = [
//     //     { severity: "Critical", color: "error", name: "Opening Spiel", subParams: 2 },
//     //     { severity: "Non Critical", color: "default", name: "Verification", subParams: 1 },
//     //     { severity: "Most Critical", color: "default", name: "Closing Spiel", subParams: 0 },
//     // ];

//     return (
//     <Box>
//         <Box
//             open
//             onClose={onClose}
//             // maxWidth="md"
//             fullWidth
//             PaperProps={{
//                 sx: {
//                     borderRadius: 3,
//                     backgroundColor: "#eaf1ff",
//                     p: 1,
//                     // maxHeight: "90vh", // Increased for better view
//                     display: "flex",
//                     flexDirection: "column"
//                 },
//             }}
//         >
//             {/* TITLE SECTION */}
//             <DialogTitle sx={{ pb: 1, flexShrink: 0 }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                     <Box sx={{ mb: 3 }}>
//                         <Typography variant="h6" fontWeight="bold">
//                             QA Parameters Configuration
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                             Manage QA parameters for{" "}
//                             <Typography component="span" sx={{ color: "#7626dc", fontWeight: 600 }}>
//                                 {processName}
//                             </Typography>
//                         </Typography>
//                     </Box>
//                     <IconButton onClick={onClose}>
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             {/* SCROLLABLE CONTENT */}
//             <Box
//                 sx={{
//                     flex: 1,
//                     overflowY: "auto",
//                     mx: 2,
//                     mt: 1,
//                     mb: 2,
//                 }}
//             >
//                 {/* WHITE INNER CARD */}
//                 <Box
//                     sx={{
//                         backgroundColor: "white",
//                         borderRadius: 2,
//                         p: 2,
//                     }}
//                 >
//                     {/* Header Row */}
//                     <Box
//                         display="flex"
//                         justifyContent="space-between"
//                         alignItems="center"
//                         sx={{ mb: 2 }}
//                     >
//                         <Typography variant="h6" fontWeight="bold">
//                             Existing Parameters
//                         </Typography>

//                         <Button
//                             variant="contained"
//                             startIcon={<AddCircleOutlineIcon />}
//                             sx={{
//                                 textTransform: "none",
//                                 backgroundColor: "#7635dc",
//                                 "&:hover": { backgroundColor: "#7635dc", color: "white" },
//                                 color: "white"
//                             }}
//                             onClick={() => {
//                                 setOpenAddModal(true)
//                                 onClose();
//                             }}
//                         >
//                             Add New Parameter
//                         </Button>
//                     </Box>

//                     <Divider sx={{ mb: 2 }} />

//                     {/* TABLE */}
//                     <Table sx={{ mt: 1 }}>
//                         <TableHead>
//                             <TableRow sx={{ color: '#888e99' }}>
//                                 <TableCell sx={{ fontWeight: 600 }}>Severity</TableCell>
//                                 <TableCell sx={{ fontWeight: 600 }}>Parameter</TableCell>
//                                 <TableCell sx={{ fontWeight: 600 }}>Sub-Parameters</TableCell>
//                                 <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
//                             </TableRow>
//                         </TableHead>

//                         <TableBody>
//                             {shortParams.map((p, index) => (
//                                 <TableRow key={index}>
//                                     <TableCell>
//                                         <Chip
//                                             label={p.severity}
//                                             size="small"
//                                             sx={{
//                                                 borderRadius: "16px",
//                                                 fontWeight: 600,
//                                                 backgroundColor:
//                                                     p.severity === "MostCritical"
//                                                         ? "#ec1010ff"
//                                                         : p.severity === "NonCritical"
//                                                             ? "#f0f0f0"
//                                                             : "white",
//                                                 color:
//                                                     p.severity === "MostCritical"
//                                                         ? "#ffffff"
//                                                         : "#000000",
//                                             }}
//                                         />
//                                     </TableCell>

//                                     <TableCell>{p.name}</TableCell>
//                                     <TableCell>{p.subParams}</TableCell>

//                                     <TableCell>
//                                         <Stack direction="row" spacing={1}>
//                                             <IconButton size="small">
//                                                 <EditIcon fontSize="small" />
//                                             </IconButton>
//                                             <IconButton size="small" sx={{ color: "red" }}>
//                                                 <DeleteIcon fontSize="small" />
//                                             </IconButton>
//                                         </Stack>
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </Box>
//             </Box>

//             {/* STATIC FOOTER */}
//             <DialogActions sx={{ px: 3, pb: 2, pt: 2, flexShrink: 0, borderTop: "1px solid #e0e0e0" }}>
//                 <Button
//                     variant="contained"
//                     onClick={onClose}
//                     sx={{
//                         textTransform: "none",
//                         backgroundColor: "#7635dc",
//                         "&:hover": { backgroundColor: "#7635dc" },
//                     }}
//                 >
//                     Close
//                 </Button>
//             </DialogActions>
//         </Box>
//         <QaParameters
//             open={openAddModal}
//             setOpenQA={setOpenQA}
//             onClose={() => setOpenAddModal(false)}
//             processName={processName}
//             QaParameters={parameter}
//         />
//     </Box>
// );
// };

// export default QAParametersModal;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Container,
  Snackbar,
  Alert,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import { jwtDecode } from 'jwt-decode';
import { useParams, useLocation } from 'react-router-dom';
import axiosInstance from '../services/axiosInterceptors';
import apiEndPointsConfig from '../services/apiEndPoints';

const QAParametersModal = () => {

  const { companyId, processType } = useParams();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const [promptData, setPromptData] = useState({})
  const [messages, setMessages] = useState(promptData);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const location = useLocation();



  console.log(companyId, "companyId", processType, "processType");

  const payload = {
    companyId,
    processType,
    promptType: "qaParameterPrompt"
  }

  const fetchClientPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.clinetPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.qaParameterPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  const updateClientPromptData = async (data) => {
    try {
      const updatePayload = {
        companyId,
        processType,
        qaParameterPrompt: messages
      };
      const res = await axiosInstance.patch(
        apiEndPointsConfig?.updateClientPrompt,
        updatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSnackbar({
        open: true,
        message: res?.data?.message || "Changes saved successfully!",
        severity: "success"
      });
      fetchClientPromptData(payload)
    } catch (error) {
      console.error("Update failed", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to update changes. Please try again.",
        severity: "error"
      });
    }
  };
  const ProcessPayload = {
    companyId,
    process: processType
  }

  const fetchProcessPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.processPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.qaParameterPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  useEffect(() => {
    if (location.state?.from === "/super-admin/process-management") {
      fetchProcessPromptData(ProcessPayload)
    } else {
      fetchClientPromptData(payload);
    }

  }, []);

  // useEffect(() => {
  //   fetchClientPromptData(payload);
  // }, []);

  const [editingMessage, setEditingMessage] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [expanded, setExpanded] = useState('m1');


  const messageTitles = {
    m1: "System Role Definition",
    m2: "Transcript Understanding",
    m3: "Entity Categories",
    m4: "Extraction Logic",
    m5: "Output Format",
    m6: "JSON Format Specification",
    m8: "Complete Kiwi Input and Output JSON Structure",
    m7: "Output Constraints"
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleEdit = (messageKey) => {
    setEditingMessage(messageKey);
    setTempValue(messages[messageKey]);
  };

  const handleSave = (messageKey) => {
    setMessages({ ...messages, [messageKey]: tempValue });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleCancel = () => {
    setEditingMessage(null);
    setTempValue('');
  };

  const handleReset = (messageKey) => {
    setMessages({ ...messages, [messageKey]: messages[messageKey] });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleResetAll = () => {
    setMessages(messages);
    setEditingMessage(null);
    setTempValue('');
  };

  const handleSaveAll = () => {
    updateClientPromptData()
  };

  const getMessageNumber = (key) => key.replace('m', '');
  const getMessageChipLabel = (key) => `M${getMessageNumber(key)}`;

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', p: 4 }}>
      <Box >
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5, color: "#7626dc" }}>
                Prompt Configuration
              </Typography>
              <Typography variant="body2">
                Configure and customize AI prompt messages for qa parameter
              </Typography>
            </Box>
            <Stack direction="row" spacing={2}>
              <Button
                startIcon={<RestoreIcon />}
                onClick={handleResetAll}
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Reset All
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveAll}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#7626dc',
                  '&:hover': { backgroundColor: '#0288d1' },
                  px: 3,
                }}
              >
                Save All Changes
              </Button>
            </Stack>
          </Box>
        </Paper>

        {/* Messages Section */}
        <Stack spacing={2}>
          {Object.entries(messages).map(([key, value]) => (
            <Accordion
              key={key}
              expanded={expanded === key}
              onChange={handleAccordionChange(key)}
              sx={{
                backgroundColor: 'white',
                '&:before': { display: 'none' },
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                borderRadius: '8px !important',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  '&:hover': { backgroundColor: '#f8f9fa' },
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
                  <Chip
                    label={getMessageChipLabel(key)}
                    size="small"
                    sx={{
                      backgroundColor: '#7626dc',
                      color: 'white',
                      fontWeight: 'bold',
                      minWidth: 45,
                    }}
                  />
                  <Typography fontWeight={600} sx={{ flexGrow: 1 }}>
                    {messageTitles[key] || 'JSON Structure'}
                  </Typography>
                  {messages[key] !== messages[key] && (
                    <Chip
                      label="Modified"
                      size="small"
                      color="warning"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Divider sx={{ mb: 2 }} />
                {editingMessage === key ? (
                  <Box>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      maxRows={12}
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'monospace',
                          fontSize: '0.9rem',
                        },
                      }}
                    />
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleSave(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Save
                      </Button>
                      <Button
                        startIcon={<CancelIcon />}
                        variant="outlined"
                        size="small"
                        onClick={handleCancel}
                        sx={{ textTransform: 'none' }}
                      >
                        Cancel
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                ) : (
                  <Box>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        mb: 2,
                        backgroundColor: '#f8f9fa',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 300,
                        overflow: 'auto',
                      }}
                    >
                      {value}
                    </Paper>
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<EditIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleEdit(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Edit Message
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>

        {/* Info Section */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mt: 3,
            backgroundColor: 'white',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Click on any message to expand and edit its content. Use "Save All Changes" to apply your modifications.
          </Typography>
        </Paper>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%', boxShadow: 3 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default QAParametersModal;
